import { render } from "./LogoutDialog.vue?vue&type=template&id=2a102324"
import script from "./LogoutDialog.vue?vue&type=script&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__